var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from "react";
import { GroupsMode } from "../../../Register";
import { AppFormContext } from "../../../../../../App";
import { Form, IconButton, Error } from "@brushfire/ui";
import { useDispatch, useSelector } from "react-redux";
import FormikContextListener from "../../../../../Helpers/FormikContextListener";
import Constants from "../../../../../../data/constants";
import * as Yup from "yup";
import { convertToFieldViews, getDefaultCountry, getDynamicFieldValidation, getRemoteFetchValues, getRemoteValidateRes, handleErrors, isVisible, } from "../../../../../../data/helpers";
import BrushfireField from "@brushfire/ui/dist/Elements/Form/BrushfireField";
import { postGroupForm } from "../../../../../../data/api";
import { setFormIsSubmitting } from "../../../../../../store/AppState/actions";
import { useIntl } from "react-intl";
import { LOCAL_STORAGE_KEYS, setLocal } from "../../../../../../data/localStorageHelpers";
import WidgetFieldset from "../../../../../Helpers/WidgetFieldset";
import useWidgetHistory from "../../../../../../hooks/useWidgetHistory";
import ReCAPTCHA from "react-google-recaptcha";
import useGroupData from "../../../../../../hooks/useGroupData";
var useTypedSelector = useSelector;
var GroupCreate = function (_a) {
    var _b, _c;
    var eventData = _a.eventData, path = _a.path, groupsMode = _a.groupsMode, setGroupsMode = _a.setGroupsMode;
    var attendeeTypeData = useTypedSelector(function (store) { return store.attendees; }).attendeeTypeData;
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var dispatch = useDispatch();
    var intl = useIntl();
    var formikContext = useContext(AppFormContext).formikContext;
    var history = useWidgetHistory();
    var groupId = useGroupData((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : 0).groupId;
    var formRef = useRef(null);
    var recaptchaRef = useRef();
    var onSubmit = function (values, formikHelpers, setGlobalError) { return __awaiter(void 0, void 0, void 0, function () {
        var token, _a, cleanedValues, cleanedInput;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    formikHelpers.setSubmitting(false);
                    return [4 /*yield*/, recaptchaRef.current.executeAsync()];
                case 1:
                    token = _b.sent();
                    values.recaptchaResponse = token;
                    formikHelpers.setSubmitting(true);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    formikHelpers.setSubmitting(false);
                    recaptchaRef.current.reset();
                    formikHelpers.setFieldError("recaptchaResponse", "Recaptcha is required.");
                    return [2 /*return*/];
                case 3:
                    dispatch(setFormIsSubmitting(true));
                    cleanedValues = Object.assign({}, values.fields);
                    Object.keys(cleanedValues).forEach(function (key) {
                        var _a, _b, _c;
                        if (Array.isArray(cleanedValues[key])) {
                            cleanedValues[key] = cleanedValues[key].filter(function (x) { return !!x; });
                            if (cleanedValues[key].some(function (x) { return !!x.price; })) {
                                var v = intl.formatNumberToParts(1000.0, {
                                    style: "currency",
                                    currency: (_a = eventData === null || eventData === void 0 ? void 0 : eventData.currency) !== null && _a !== void 0 ? _a : "USD",
                                });
                                var symbol_1 = ((_b = v.find(function (x) { return x.type === "currency"; })) === null || _b === void 0 ? void 0 : _b.value) || "$";
                                var isCommaDecimal_1 = ((_c = v.find(function (x) { return x.type === "decimal"; })) === null || _c === void 0 ? void 0 : _c.value) === ",";
                                cleanedValues[key].forEach(function (opt) {
                                    var _a, _b;
                                    if (isNaN(opt.price)) {
                                        opt.price = opt.price
                                            ? opt.price === ""
                                                ? 0
                                                : isCommaDecimal_1
                                                    ? parseFloat(((_a = opt.price) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "").replace(",", ".").replace(symbol_1 || "$", "")) || "0.00")
                                                    : parseFloat(((_b = opt.price) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, "").replace(symbol_1 || "$", "")) || "0.00")
                                            : 0;
                                    }
                                });
                            }
                        }
                    });
                    cleanedInput = {
                        attendeeTypeId: values.attendeeTypeId,
                        name: values.name,
                        email: values.email,
                        joinCode: values.joinCode,
                        communityId: values.communityId,
                        fields: Object.keys(cleanedValues).map(function (key) { return ({ id: key, value: cleanedValues[key] }); }),
                        recaptchaResponse: values.recaptchaResponse,
                    };
                    postGroupForm(cleanedInput)
                        .then(function (_a) {
                        var _b;
                        var data = _a.data;
                        setLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : ""), JSON.stringify({ groupId: data.id, name: data.name }), 60 * 30);
                        setGroupsMode(GroupsMode.hide);
                    })
                        .catch(function (err) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                        (_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
                        if (((_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) && !((_e = (_d = err.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors)) {
                            setGlobalError(err.response.data.message);
                        }
                        var filteredError = Object.assign({}, err);
                        if ((_g = (_f = err.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.errors) {
                            filteredError.response.data.errors =
                                (_l = (_k = (_j = (_h = err.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.errors) === null || _k === void 0 ? void 0 : _k.map(function (error) { return ({
                                    key: error.key.replace("fields[", "fields.").replace("].value", ""),
                                    value: error.value,
                                }); })) !== null && _l !== void 0 ? _l : [];
                        }
                        handleErrors(filteredError, dispatch, formikContext, setGlobalError);
                    })
                        .finally(function () {
                        dispatch(setFormIsSubmitting(false));
                        formikHelpers.setSubmitting(false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var getInitialValues = function (fieldViews) {
        var _a;
        var groupTypes = (_a = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return a.isGroup; })) !== null && _a !== void 0 ? _a : [];
        var ret = {
            fields: {},
            attendeeTypeId: groupTypes.length ? groupTypes[0].id : null,
        };
        fieldViews.forEach(function (field) {
            if (field.childFields.length === 0) {
                if (Constants.FieldsWithOptions.includes(field.type)) {
                    var val_1 = [];
                    if (Array.isArray(field.value)) {
                        var values_1 = field.value;
                        field.options.forEach(function (opt, index) {
                            var found = values_1.find(function (v) { return v.id === opt.id; });
                            val_1[index] = found ? found : null;
                        });
                    }
                    ret.fields[field.id] = val_1;
                }
                else {
                    ret.fields[field.id] = field.value;
                }
            }
            else {
                field.childFields.forEach(function (child) {
                    ret.fields[child.id] = child.value;
                });
            }
        });
        return ret;
    };
    var fieldViews = (eventData === null || eventData === void 0 ? void 0 : eventData.groupFields) ? convertToFieldViews(eventData === null || eventData === void 0 ? void 0 : eventData.groupFields) : [];
    var fieldShape = getDynamicFieldValidation(fieldViews);
    var CreateSchema = Yup.object().shape({
        name: Yup.string()
            .min(5, "Group name must be at least 5 characters")
            .max(50, "Group name must 50 characters or less")
            .required("Group name is required"),
        attendeeTypeId: Yup.string().required("".concat((eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? "Ticket" : "Registration", " type required")),
        email: Yup.string()
            .email("Email must be a valid email address")
            .required("Your email is required"),
        joinCode: Yup.string().required("Passcode is required"),
        fields: Yup.object().shape(fieldShape),
    });
    var getRemoteValidateLocal = function (fieldId, value, setResponse) {
        var _a;
        return getRemoteValidateRes(fieldId, value, setResponse, (_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _a !== void 0 ? _a : 0);
    };
    var getRemoteFetchValuesLocal = function (fieldId, value, setRemoteData) {
        var _a;
        return getRemoteFetchValues(fieldId, value, setRemoteData, (_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _a !== void 0 ? _a : 0);
    };
    var commonTypeData = ((eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric)
        ? attendeeTypeData !== null && attendeeTypeData !== void 0 ? attendeeTypeData : []
        : (_c = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return a.isGroup; })) !== null && _c !== void 0 ? _c : [])
        .filter(function (type) { return type.isAvailable; })
        .map(function (type) {
        var _a;
        return ({
            label: "".concat(type.name).concat(type.quantityRequirements && type.quantityRequirements !== "" ? " (".concat(type.quantityRequirements, ")") : "", " - ").concat(intl.formatNumber((_a = type.displayAmount) !== null && _a !== void 0 ? _a : 0, {
                currency: eventData === null || eventData === void 0 ? void 0 : eventData.currency,
                style: "currency",
            })).concat(type.priceDescription ? " (".concat(type.priceDescription, ")") : ""),
            value: type.id,
        });
    });
    useEffect(function () {
        var _a, _b;
        var formik = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.myFormikRef.current;
        if ((commonTypeData.length === 1 ||
            ((eventData === null || eventData === void 0 ? void 0 : eventData.isGroupCentric) &&
                commonTypeData.length > 0 &&
                !(attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.some(function (x) { return x.groupingText; })))) &&
            (formik === null || formik === void 0 ? void 0 : formik.values.attendeeTypeId) !== ((_b = commonTypeData[0]) === null || _b === void 0 ? void 0 : _b.value)) {
            formik === null || formik === void 0 ? void 0 : formik.setFieldValue("attendeeTypeId", commonTypeData[0].value);
        }
    }, [formRef, commonTypeData]);
    if (!eventData) {
        return null;
    }
    return (_jsx(_Fragment, { children: _jsx(Form, __assign({ ref: formRef, initialValues: getInitialValues(fieldViews), onSubmit: onSubmit, validationSchema: CreateSchema, useUnsavedPrompt: false }, { children: function (_a) {
                var formikContext = _a.formikContext;
                return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: path, path: [
                                Constants.Routes.register,
                                Constants.Routes.tickets,
                                Constants.Routes.autoreg,
                                Constants.Routes.calendar,
                                Constants.Routes.section,
                            ], formikContext: formikContext, active: groupsMode === GroupsMode.createGroup }), _jsxs(WidgetFieldset, { children: [_jsxs("div", __assign({ className: "d-flex align-items-center justify-content-between" }, { children: [_jsx("h4", __assign({ className: "semi-bold mb-0" }, { children: "Create A Group" })), _jsx(IconButton, { ariaLabel: "Back to Group Choices", icon: "times", classes: "d-inline-flex m-left p-top-icon-3", onClick: function (evt) {
                                                evt.stopPropagation();
                                                evt.preventDefault();
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                //@ts-ignore
                                                formikContext.resetForm({ values: getInitialValues(fieldViews) });
                                                if (!eventData.isGroupCentric || groupId) {
                                                    setGroupsMode(GroupsMode.hide);
                                                }
                                                else {
                                                    setGroupsMode(GroupsMode.buttons);
                                                }
                                            } })] })), _jsx("p", __assign({ className: "p-top" }, { children: "Creating a Group will allow you to register multiple attendees and manage your tickets and registrations. You'll also be able to invite others to join your group later." })), (eventData === null || eventData === void 0 ? void 0 : eventData.hasExistingGroups) && (_jsx("p", { children: _jsx("a", __assign({ href: "#", onClick: function (evt) {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            //@ts-ignore
                                            formikContext.resetForm({ values: getInitialValues(fieldViews) });
                                            setGroupsMode(GroupsMode.joinGroup);
                                        }, className: "btn btn-sm btn-secondary unstyled-link" }, { children: "Join a group instead" })) })), _jsx(Form.Field, { label: "Name of your group", name: "name", id: "name" }), _jsx(Form.Field, { label: "Your group's most common ".concat(eventData.verbiage === "Tickets" ? "ticket" : "registration", " type"), component: Form.Input.Select, id: "attendeeTypeId", name: "attendeeTypeId", data: commonTypeData, autoComplete: "off", isSearchable: false }), _jsx(Form.Field, { label: "Your email address", name: "email", id: "createEmail" }), _jsx(Form.Field, { label: "Passcode to join this group", id: "createJoinCode", name: "joinCode", autoComplete: "new-off", description: "This is a simple, easy-to-remember code you'll share with others who will join your group later. Not case sensitive." }), fieldViews.map(function (field, index) {
                                    var visible = isVisible(field, formikContext.values.fields, fieldViews);
                                    if (visible) {
                                        return (_jsx(BrushfireField, { id: "".concat(field.id), name: "".concat(field.id), prefix: "fields.", fieldItem: field, currency: eventData.currency, remoteValidate: getRemoteValidateLocal, remoteFetch: getRemoteFetchValuesLocal, defaultCountry: getDefaultCountry(eventData), intl: intl }, field.id || index.toString()));
                                    }
                                }), _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: Constants.RecaptchaSiteKey, onChange: function (value) {
                                        formikContext.setFieldValue("recaptchaResponse", value);
                                    }, size: "invisible" }), _jsxs("p", __assign({ className: "mini" }, { children: ["This site is protected by reCAPTCHA and the Google", " ", _jsx("a", __assign({ href: "https://policies.google.com/privacy" }, { children: "Privacy Policy" })), " and", " ", _jsx("a", __assign({ href: "https://policies.google.com/terms" }, { children: "Terms of Service" })), " apply."] })), formikContext.errors.recaptchaResponse && formikContext.submitCount > 0 && (_jsx(Error, { children: formikContext.errors.recaptchaResponse }))] })] }));
            } })) }));
};
export default GroupCreate;
